// extracted by mini-css-extract-plugin
export default {"locationContainer":"property_location_locationContainer__Rmzrp","icon":"property_location_icon__wE7Kp"};